
import { useState, useEffect } from 'react';
import { paymentServiceApi } from '@/services/api';
import { analyticsService } from '@/services/analyticsService';

export interface SubscriptionStatus {
    is_active: boolean;
    end_date: string;
    start_date: string;
    days_left: number;
    plan_name: string;
    message: string;
}

export const useSubscriptionStatus = () => {
    const [data, setData] = useState<SubscriptionStatus | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let mounted = true;
        const fetchStatus = async () => {
            try {
                const res = await paymentServiceApi.get<SubscriptionStatus>('/subscriptions/status');
                if (mounted) {
                    if (res.success && res.data) {
                        setData(res.data);
                        void analyticsService.setSubscriptionStatus(res.data.is_active);
                    } else {
                        setError(res.error || 'Failed to fetch subscription status');
                    }
                }
            } catch (err: any) {
                if (mounted) setError(err.message || 'Error fetching subscription status');
            } finally {
                if (mounted) setIsLoading(false);
            }
        };

        fetchStatus();
        return () => { mounted = false; };
    }, []);

    return { 
        data, 
        isLoading, 
        error,
        isSubscriptionActive: data?.is_active ?? false
    };
};
